"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _useInterval = _interopRequireDefault(require("../../hooks/useInterval"));
var _animatedLoaderPaths = require("./animatedLoaderPaths");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SQUIGGLE_ANIMATION_DELAY_MS = 1500;
var SQUIGGLE_ANIMATION_FRAME_MS = 10;
var getSpeed = function getSpeed() {
  if (typeof window === 'undefined') {
    return 1;
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 99.95 : 1;
};
var AnimatedLoaderSquiggle = function AnimatedLoaderSquiggle(_ref) {
  var squiggleColor = _ref.squiggleColor,
    onAnimationComplete = _ref.onAnimationComplete;
  var _React$useState = _react["default"].useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    pathIndex = _React$useState2[0],
    setPathIndex = _React$useState2[1];
  var delayRef = _react["default"].useRef(0);
  var speed = getSpeed();
  (0, _useInterval["default"])(function () {
    if (pathIndex >= _animatedLoaderPaths.animatedLoaderPaths.length - 1) {
      delayRef.current += SQUIGGLE_ANIMATION_FRAME_MS;
      if (delayRef.current >= SQUIGGLE_ANIMATION_DELAY_MS) {
        delayRef.current = 0;
        setPathIndex(0);
        onAnimationComplete();
      }
      return;
    }
    setPathIndex(function (index) {
      return index + 1;
    });
  }, SQUIGGLE_ANIMATION_FRAME_MS * speed);
  return /*#__PURE__*/_react["default"].createElement("svg", {
    "aria-labelledby": "animatedLoaderSquiggle",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 472 287",
    width: "472",
    height: "287",
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: '100%',
      height: '100%',
      transform: 'translate3d(0px, 0px, 0px)',
      contentVisibility: 'visible'
    }
  }, /*#__PURE__*/_react["default"].createElement("title", {
    id: "animatedLoaderSquiggle"
  }, "Animated squiggle logo"), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "animatedLoaderSquiggleRect"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "472",
    height: "287",
    x: "0",
    y: "0"
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#animatedLoaderSquiggleRect)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(0.5205000042915344,0,0,0.5205000042915344,223,137.5)",
    opacity: "1",
    style: {
      display: 'block'
    }
  }, /*#__PURE__*/_react["default"].createElement("g", {
    className: "TMSquiggle",
    opacity: "1",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    fillOpacity: "0",
    stroke: squiggleColor,
    strokeOpacity: "1",
    strokeWidth: "38",
    d: _animatedLoaderPaths.animatedLoaderPaths[pathIndex]
  })), /*#__PURE__*/_react["default"].createElement("g", {
    opacity: "1",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: "0",
    strokeMiterlimit: "4",
    stroke: "rgb(38,26,145)",
    strokeOpacity: "1",
    strokeWidth: "38",
    d: "M0 0"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    opacity: "1",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: "0",
    strokeMiterlimit: "4",
    stroke: "rgb(38,26,145)",
    strokeOpacity: "1",
    strokeWidth: "38",
    d: "M0 0"
  })))));
};
AnimatedLoaderSquiggle.propTypes = {
  squiggleColor: _propTypes["default"].string.isRequired,
  onAnimationComplete: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = AnimatedLoaderSquiggle;